import React from "react";
import { useTranslation } from "react-i18next";
import LifestyleUseCases from "../LifestyleUseCases";
import { useWatchLifestyleData } from "./watchData";

const LifestyleUseCasesWatch: React.FC = () => {
    const { t } = useTranslation("watchLifestyle");
    const watchLifestyleData = useWatchLifestyleData();

    return (
        <LifestyleUseCases
            data={watchLifestyleData}
            sectionTitle={{
                regularText: t("sectionTitle.regularText"),
                highlightedText: t("sectionTitle.highlightedText"),
                descriptionHighlight: t("sectionTitle.descriptionHighlight"),
                descriptionText: t("sectionTitle.descriptionText"),
            }}
            className="watch-lifestyle-section"
        />
    );
};

export default LifestyleUseCasesWatch;
